import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';
import { ProjectTechnology, TechnologyCollection, HidropowerProjectTechnology } from '@/features/projects/types';
import { HidropowerForm } from './hidropower-form';

export type HidropowerDrawerProps = {
  readonly formId: string;
  readonly technology: ProjectTechnology;
  readonly isOpen: boolean;
  readonly onSubmit: (
    collection: TechnologyCollection,
    item: HidropowerProjectTechnology,
    description?: string
  ) => void;
  readonly onClose: () => void;
};

export function HidropowerDrawer({ formId, technology, isOpen, onSubmit, onClose }: HidropowerDrawerProps) {
  const { t } = useTranslation(['projects']);
  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Hydropower Details & Design')} open={isOpen} onClose={onClose} footer={footer}>
      <HidropowerForm
        id={formId}
        item={technology?.item as HidropowerProjectTechnology}
        onSubmit={(data: any) =>
          onSubmit(
            'projects_hidropower_technologies',
            { ...technology?.item, ...data },
            t('Hydropower Details has been updated')
          )
        }
      />
    </Drawer>
  );
}
